export function normalize_template_form(form) {
  if (!form || typeof form !== 'object') return null;
  if (!form.template_form_id) return null;

  return {
    ...form,
    form_name: String(form.form_name || '').trim(),
    form_description: String(form.form_description || '').trim(),
    is_active: form.is_active !== false,
    created_at: form.created_at || null,
  };
}

export function normalize_onboarding_form(form) {
  if (!form || typeof form !== 'object' || !form.id) return null;

  return {
    id: String(form.id),
    title: String(form.form_name || '').trim(),
    description: String(form.form_description || '').trim(),
  };
}

export function normalize_assigned_onboarding_form(item) {
  if (!item || typeof item !== 'object' || !item.onboarding_form_id) return null;

  return {
    id: String(item.onboarding_form_id),
    title: String(item.onboarding_form_name || '').trim(),
    description: '',
  };
}

export function create_template_form_management_data() {
  return {
    active_tab: 'forms',
    template_forms: [],
    onboarding_forms: [],
    selected_assign_template_form: null,
    linked_onboarding_form_ids: {},
    form_name: '',
    form_description: '',
    is_loading: false,
    is_loading_onboarding_forms: false,
    is_loading_assignments: false,
    is_submitting_assignment: false,
    assignment_target_onboarding_form_id: '',
    is_saving: false,
  };
}

const template_form_management_computed = {
  is_forms_tab() {
    return this.active_tab === 'forms';
  },
  banner_title() {
    return this.is_forms_tab ? 'Template Forms' : 'E-signing Workflows';
  },
  banner_subtitle() {
    return this.is_forms_tab
      ? 'Create forms used for e-signing template onboarding and assignment flows.'
      : 'Create and manage the workflows used for e-signing templates.';
  },
  banner_action_label() {
    return this.is_forms_tab ? 'Create New Form' : 'Create Workflow';
  },
  banner_action_target() {
    return this.is_forms_tab ? '#create_template_form' : '#create_esigning_workflow_modal';
  },
  has_forms() {
    return this.template_forms.length > 0;
  },
  selected_assign_template_form_id() {
    return String(this.selected_assign_template_form?.template_form_id || '').trim();
  },
  selected_assign_template_form_name() {
    return String(this.selected_assign_template_form?.form_name || '').trim();
  },
};

export default template_form_management_computed;
